import * as Sentry from '@sentry/vue';
import axios from 'axios';

// SENTRY_RELEASE is baked at build time via Vite define\
// eslint-disable-next-line typescript/naming-convention
declare const __SENTRY_RELEASE__: string;

export function initSentry(app: any, router: any) {
  Sentry.init({
    app,
    enabled: ['production', 'staging'].includes(import.meta.env.SENTRY_ENV),
    environment: import.meta.env.SENTRY_ENV,
    release: __SENTRY_RELEASE__ || undefined,
    dsn: import.meta.env.SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    beforeSend(event, hint) {
      const message = event.exception?.values?.[0]?.value ?? '';

      // Ignore chunk loading errors caused by SPA updates.
      // This happens when the app is deployed and the browser tries to load an outdated hashed chunk (404).
      // It is an expected scenario and handled by showing the "VReloadView" page.
      if (
        message.includes('Loading chunk') ||
        message.includes('ChunkLoadError') ||
        message.includes('Failed to fetch dynamically imported module')
      ) {
        return null;
      }

      // decided not to send certain network errors
      if (
        hint?.originalException &&
        axios.isAxiosError(hint.originalException)
      ) {
        const ignoredStatuses = [401, 404];
        if (
          ignoredStatuses.includes(
            hint.originalException.response?.status as number,
          )
        ) {
          return null;
        }
      }
      return event;
    },
    tracesSampler: (ctx) => ctx.parentSampled ? 1.0 : 0.01,
    tracePropagationTargets: [`${window.location.origin}/api`, /^\/api\//],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
  });
}

export default initSentry;
